import { Form } from '@calendly/form'
import { usePageTitle } from '@calendly/hooks'
import { I18n } from '@calendly/i18n'
import { useMemo } from 'react'
import { useDispatch } from 'react-redux'

import LoadingState from 'components/core/loading_state'

import {
  useGetPaymentsSettingsQuery,
  useUpdateOrganizationPaymentsSettingsMutation
} from './api'
import { Description } from '../styles'
import { FormContent } from './form_content'

export const Payments = () => {
  const dispatch = useDispatch()
  const { data, isLoading } = useGetPaymentsSettingsQuery()
  const [updateOrganizationPaymentsSettings] = useUpdateOrganizationPaymentsSettingsMutation()

  usePageTitle(`${I18n.t('publisher.admin.permissions.tabs.payments')} - ${I18n.t('publisher.admin.permissions.title')}`)

  const initialValues = useMemo(() => ({
    paymentsAccess: data?.paymentsDisabledByAdmin ? 'no_one' : 'everyone'
  }), [data?.paymentsDisabledByAdmin])

  const handleSubmit = ({ paymentsAccess }) => (
    dispatch(updateOrganizationPaymentsSettings({
      paymentsDisabledByAdmin: paymentsAccess === 'no_one'
    }))
  )

  if (isLoading) return <LoadingState />

  return (
    <>
      <Description>
        {I18n.t('publisher.organization_settings.payments.description')}
      </Description>
      <Form
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        <FormContent />
      </Form>
    </>
  )
}
